import React from 'react'

const InstructionModal = ({ OkClick, description }) => {
  const OnOkClick = () => {
    OkClick()
  }

  const closeModal = () => {
    OkClick();
  };

  return (
    <>
      <section className="delete-modal">
        <div
          className="modal"
          id="infoModal"
          tabIndex={-1}
          aria-labelledby="ModalFormLabel"
          aria-hidden="true"
          style={{
            display: "block",
            paddingRight: "17px",
            backgroundColor: "#00000094",
          }}
        >
          <div
            className="modal-dialog modal-dialog-centered"
            style={{ maxWidth: "500px", width: "100%" }}
          >
            <div className="modal-content">
              <div className="modal-header">
                <button
                  type="button"
                  className="close"
                  onClick={closeModal}
                  style={{
                    backgroundColor: "white",
                    border: "none",
                    color: "red",
                    fontSize: "2rem",
                    fontWeight: "bold",
                    width: "30px",
                    height: "30px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    position: "absolute",
                    top: "1px",
                    right: "10px",
                    cursor: "pointer",
                  }}
                >
                  &times;
                </button>
              </div>
              <div className="modal-body">
                <div className="container">
                  <div className="delete-modal-main">
                    <div className="text-input-main">
                      <div
                        className="modal-body"
                        dangerouslySetInnerHTML={{ __html: description }}
                      />
                      {/* Render the description JSX or component directly */}
                      {/* <div className="modal-body">
                        {description}
                      </div> */}
                      <div
                        className="confirm-btn-div"
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            marginTop: "20px",
                        }}
                        >
                        <button
                            className="modal-close-btn"
                            onClick={OnOkClick}
                            style={{
                            backgroundColor: "#007bff",   // nice blue
                            color: "white",
                            border: "none",
                            borderRadius: "5px",
                            padding: "6px 20px",          // small size
                            fontSize: "14px",
                            cursor: "pointer",
                            transition: "background-color 0.3s ease",
                            }}
                            onMouseOver={(e) => (e.target.style.backgroundColor = "#0056b3")}
                            onMouseOut={(e) => (e.target.style.backgroundColor = "#007bff")}
                        >
                            Ok
                        </button>
                        </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default InstructionModal;
